import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { postAsync } from "../../services/ApiHandler";
import { useHeaderStore } from "../../parts/CommonHeader";
import { isLoggedIn } from "../../services/CookieHandler";
import { getAccountId } from "../../services/CookieHandler";

export const AdvancedFreePlanPage: FC = () => {
  const search = useLocation().search;
  const { fetchActiveSubscription, fetchRemainCount } = useHeaderStore();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const sessionId = query.get('session_id');
    if (sessionId !== undefined && isLoggedIn()) {
      postSessionId(sessionId!.toString());
    }
    
    // もしもアフィリエイトコンバージョンタグ追加
    const accountId = getAccountId();
    if (accountId) {
      // scriptタグ追加
      const script = document.createElement('script');
      script.src = `https://r.moshimo.com/af/r/result.js?p_id=6647&pc_id=18944&m_v=${accountId}_standard`;
      script.id = 'msmaf';
      document.body.appendChild(script);
      
      // noscriptタグの代替としてimgタグ追加
      const img = document.createElement('img');
      img.src = `https://r.moshimo.com/af/r/result?p_id=6647&pc_id=18944&m_v=${accountId}_standard`;
      img.width = 1;
      img.height = 1;
      img.alt = '';
      img.style.display = 'none';
      document.body.appendChild(img);
    }
  }, []);

  async function postSessionId(sessionId: string) {
    const param = {
      sessionId: sessionId
    };
    await postAsync<string>("Stripe/CompletePurchase", param); 
    fetchActiveSubscription();
    fetchRemainCount();
  }

  return <>
    <Helmet>
      <title>Advancedプラン無料トライアル申込完了</title>
      <meta name="description" content="無料トライアル申込完了" />
    </Helmet>
    <div className="mt-4 text-base sm:text-lg font-bold">Advancedプランの無料トライアル申込が完了しました！</div>
  </>;
}
